
import { LabelsMdl } from "../../Modal/Labels";
import { action } from 'typesafe-actions';
import { Constants } from "../labels/labelsTypes";
export function storeLabels(payload: LabelsMdl[]) {
    return action(
        Constants.SET_LABELES, {
            labels: payload
    })
}